const generateCloudinaryLink = (imageName, width) => {
    if (!!imageName) {
        const imageUrl = `https://res.cloudinary.com/dbwzzukjo/image/upload/v1684157950/${width ? "c_scale,w_" + width + "/" : ""}${imageName}`;
        return imageUrl;
    }
};

export default generateCloudinaryLink;
